import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import { ActivatedRoute, Router } from "@angular/router";

import { ProdutoEntradaService } from '../services/produto-entrada.service';
import { ProdutoService } from '../services/produto.service';
import { ExcelService } from '../services/excel.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-produto-entrada',
  templateUrl: './produto-entrada.component.html',
  styleUrls: ['./produto-entrada.component.css'],
  animations: [loadingFade, modal, alert]
})
export class ProdutoEntradaComponent implements OnInit {
  public loading = false;
  public entradas;

  // paginacao
  public page = 1;
  public limit = 10;
  public count = 0;

  // filtro
  public filtro = [];
  public dadosFiltrados = [];
  public formFiltro: FormGroup;
  public showFilter = true;
  public produtos;
  
  // datepickers
  public data_entrada_dp;

  constructor(private fb: FormBuilder,
              private produtoEntradaSvc: ProdutoEntradaService,
              private produtoSvc: ProdutoService,
              private router: Router,	
              private route: ActivatedRoute,	
              private excelSvc: ExcelService) { }

  ngOnInit() {
    this.pegaProdutos();
    this.criaFiltro();
    this.pegaEntradas();
  }

  pegaEntradas(){
    this.loading = true;
    this.produtoEntradaSvc.getProdutoEntradas().then((data: any) =>{
      this.entradas = data;
      this.count = this.entradas.length;
      this.loading = false;
    }).catch((err) => {
      console.log(err);
      this.loading = false;
    });
  }

  pegaProdutos(){
    this.produtoSvc.getProdutos().then((data: any) =>{
      this.produtos = data;
    }).catch((err) =>{
      console.log(err);
    });
  }

  primPagina() {
    this.page = 1;
  }

  paginaAnt() {
    this.page = Math.max(this.page - 1, 1);
  }

  proxPagina() {
    this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
  }

  ultPagina() {
    this.page = Math.ceil(this.count / this.limit);
  }

  apagaEntrada(id) {
    Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.produtoEntradaSvc.apagaProdutoEntrada(id).then((data) => {
					this.pegaEntradas();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
  }

  criaFiltro() {
    this.formFiltro = this.fb.group({
      produto_entrada_nf___nota: '',
      produto_id___produto: null,
      produto_entrada_data___data_i: null,
      produto_entrada_data___data_f: null
    });

    let campos_data = ['produto_entrada_data___data_i', 'produto_entrada_data___data_f'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}

    this.route.params.subscribe( params => {

			if(params.id){
	  
			  let splitF = params.id.split("&");
	  
			  let loNota = null;
			  let loProdutoID = null;
			  let loTipoMulta = null;
			  let loData_i = "";
			  let loData_f = "";
	  
			  this.showFilter = false;
	  
			  for (var i = 0; i < splitF.length; i++) {
	  
				var loSplitValor = splitF[i].split("=");
	  
				switch(loSplitValor[0]) { 
				  case "produto_entrada_nf___nota": { 
	  
					if(loSplitValor[1] !== "null"){
					  loNota = loSplitValor[1];
					}
					 break; 
	  
				  } 
				  case "produto_id___produto": { 
					if(loSplitValor[1] !== "null"){
					  loProdutoID = parseInt(loSplitValor[1]);
					}
	  
					break; 
				  }
				  case "produto_entrada_data___data_i": { 
					if(loSplitValor[1] !== "null"){
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				  case "produto_entrada_data___data_f": { 
					if(loSplitValor[1] !== "null"){
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				 }
	  
			  }
			  this.preencheForm({
          produto_entrada_nf___nota: loNota,
          produto_id___produto: loProdutoID,
				  produto_entrada_data___data_i: loData_i,
				  produto_entrada_data___data_f: loData_f
			  });
			  this.filtra();
	  
			}
	  
		  });	    

  }

  preencheForm(dados) {
		this.formFiltro.setValue(dados);
	}

  filtra() {
    this.filtro = this.formFiltro.value;
    this.dadosFiltrados = new FiltroPipe().transform(this.entradas, this.filtro);
    this.count = this.dadosFiltrados.length;
    this.page = 1;
  }

  expandPanel() {
    this.showFilter = this.showFilter == true ? false : true;
  }
  
  exportarExcel() {
    let data = [];
    if (this.dadosFiltrados.length == 0) {
      this.dadosFiltrados = this.entradas;
    }
    for (let index in this.dadosFiltrados) {
      data[index] = {
        'Data':             moment(this.dadosFiltrados[index].produto_entrada_data).format('DD/MM/YYYY'),
        'Nota':             this.dadosFiltrados[index].produto_entrada_nf,
        'Preço de Compra':  this.dadosFiltrados[index].produto_entrada_valor_total,
        'Quantidade':       this.dadosFiltrados[index].produto_entrada_quantidade,
        'Cod. Produto':     this.dadosFiltrados[index].produto.produto_codigo,
        'Descrição':        this.dadosFiltrados[index].produto.produto_descricao,
        'Fornecedor':       this.dadosFiltrados[index].produto.fornecedor.fornecedor_nome,
        'Localização':      this.dadosFiltrados[index].produto.produto_localizacao,
      };
    }

    this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Entrada de produtos');
  }


	Edit(produto_entrada_id){

		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		//Envia dados
		this.router.navigate(['home/produto-entrada/edit/' + produto_entrada_id + params] );
	}

  Ver(produto_entrada_id){
    this.router.navigate(['home/produto-entrada/ver/' + produto_entrada_id] );
  }

    onClickLimparCampos(){
      this.formFiltro = this.fb.group({
        produto_entrada_nf___nota: '',
        produto_id___produto: null,
        produto_entrada_data___data_i: null,
        produto_entrada_data___data_f: null
      });
    }

}
